export default __webpack_public_path__ + "static/media/home-banner-desktop.da9230f6.png";